import logo200Image from '../../assets/img/logo/logo_2.png'
import sidebarBgImage from '../../assets/img/sidebar/sidebar-4.jpg'
import SourceLink from '../../components/SourceLink'
import React from 'react'
import { FaRegIdCard } from 'react-icons/fa'
import {
  MdAccountCircle,
  MdArrowDropDownCircle,
  MdBorderAll,
  MdBrush,
  MdChromeReaderMode,
  MdDashboard,
  MdExtension,
  MdGroupWork,
  MdInsertChart,
  MdKeyboardArrowDown,
  MdNotificationsActive,
  MdPages,
  MdRadioButtonChecked,
  MdSend,
  MdStar,
  MdTextFields,
  MdViewCarousel,
  MdViewDay,
  MdViewList,
  MdWeb,
  MdWidgets,
  MdLocalGroceryStore,
  MdBuild,
  MdGroup,
  MdSubject,
  MdDomain,
  MdPerson,
  MdMyLocation,
  MdFace,
  MdRssFeed,
  MdStayCurrentPortrait,
  MdThumbUp,
  MdSettings,
  MdContentPaste,
  MdAssessment,
  MdAssignment,
  MdShowChart,
  MdDescription,
  MdReceipt
} from 'react-icons/md'
import { NavLink } from 'react-router-dom'
import {
  // UncontrolledTooltip,
  Collapse,
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap'
import bn from '../../utils/bemnames'
import Typography from '../../components/Typography'
import axios from 'axios'
import StorageService from '../../services/StorageService'
import { roleData } from '../../data/jsonData'

const personnelItems = [
  {
    to: '/person',
    name: 'Person',
    exact: true,
    Icon: MdGroup,
  },
  {
    to: '/site',
    name: 'Site',
    exact: true,
    Icon: MdMyLocation,
  },
  {
    to: '/configuration',
    name: 'Configuration',
    exact: true,
    Icon: MdBuild,
  },
]

const posItems = [
  // {
  //   to: '/pos',
  //   name: 'POS Page',
  //   exact: true,
  //   Icon: MdGroup,
  // },
  {
    to: '/posstore',
    name: 'Store',
    exact: true,
    Icon: MdDomain,
  },
  {
    to: '/posproduct',
    name: 'Product',
    exact: true,
    Icon: MdLocalGroceryStore,
  },
  {
    to: '/posuser',
    name: 'mPOS User',
    exact: true,
    Icon: MdGroup,
  },
  {
    to: '/posorder',
    name: 'Order',
    exact: true,
    Icon: MdContentPaste,
  },
  {
    to: '/posreport',
    name: 'Report',
    exact: true,
    Icon: MdAssessment,
  },
  {
    to: '/posmanagement',
    name: 'Management',
    exact: true,
    Icon: MdAssignment,
  },
  {
    to: '/posanalytic',
    name: 'Analytics',
    exact: true,
    Icon: MdShowChart,
  },
]

const crmItems = [
  {
    to: '/crmcustomer',
    name: 'Customer',
    exact: true,
    Icon: MdGroup,
  },
  {
    to: '/crmcampaign',
    name: 'Campaign',
    exact: true,
    Icon: MdRssFeed,
  },
]

const configItems = [
  {
    to: '/company',
    name: 'Company',
    exact: true,
    Icon: MdDomain,
  },
  {
    to: '/user',
    name: 'System User',
    exact: true,
    Icon: MdPerson,
  },
  {
    to: '/licensing',
    name: 'POS Licensing',
    exact: true,
    Icon: MdDescription,
  },
  {
    to: '/outstanding-billing',
    name: 'Outstanding Billing',
    exact: true,
    Icon: MdReceipt,
  }
]

const userItems = [
  {
    to: '/company-user',
    name: 'Company User',
    exact: true,
    Icon: MdPerson,
  },
]

const appItems = [
  {
    name: 'Personnel',
    to: '/person',
    Icon: MdFace,
    menu: personnelItems,
    exact: true,
    id: 1,
  },
  {
    name: 'POS',
    to: '/posstore',
    Icon: MdStayCurrentPortrait,
    menu: posItems,
    exact: true,
    id: 2,
  },
  {
    name: 'CRM',
    to: '/crmcustomer',
    Icon: FaRegIdCard,
    menu: crmItems,
    exact: true,
    id: 3,
  },
  {
    name: 'Configuration',
    to: '/company',
    Icon: MdSettings,
    menu: configItems,
    exact: true,
    id: 4,
  },
  {
    name: 'User',
    to: '/company-user',
    Icon: MdGroup,
    menu: userItems,
    exact: true,
    id: 5,
  },
]

const bem = bn.create('sidebar')

class Sidebar extends React.Component {
  state = {
    isOpenComponents: true,
    isOpenContents: true,
    isOpenPages: true,
  }

  handleClick = name => () => {
    this.setState(prevState => {
      const isOpen = prevState[`isOpen${name}`]

      return {
        [`isOpen${name}`]: !isOpen,
      }
    })
  }

  selectApp = id => {
    StorageService.setSession('activeApp', id)
  }

  getOrganisationList = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_API_URL
    const selected_org = StorageService.getSession('selected_org')

    const data = {
      session_key: user.session_key,
    }

    axios
      .post(url + ':3000/v1/company/getUserCompany', data)
      .then(response => {
        const result = response.data

        if (result.error == 'true' && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (result.data.length > 0 && selected_org == null) {
          StorageService.setSession('selected_org', result.data[0])
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  componentDidMount() {
    this.getOrganisationList()
  }

  render() {
    const parentPath = window.location.pathname.split('/')[1]
    const activeApp = StorageService.getSession('activeApp')
    const user = StorageService.getSession('user_info')
    const org = StorageService.getSession('selected_org')
    const path = window.location.pathname
    let mainMenuItems = [...appItems]

    if (org && org.Features.length > 0) {
      var tempArr = mainMenuItems.filter(function (obj) {
        return org.Features.some(function (obj2) {
          return obj.id == obj2.RowOrder
        })
      })
      mainMenuItems = tempArr
      let found = mainMenuItems.findIndex(el => el.id === activeApp + 1)
      if (found < 0) {
        StorageService.setSession('activeApp', mainMenuItems[0].id - 1)
      }
    } else {
      mainMenuItems = []
    }

    let idx = mainMenuItems.findIndex(el => el.name === 'Configuration')

    if (!user.superUser) {
      if (idx > -1) {
        mainMenuItems.splice(idx, 1) //remove config from app
      }
    }

    let uidx = mainMenuItems.findIndex(el => el.name === 'User')
    if (uidx > -1) {
      // const found = roleData.some(el => el.role === org.Role);
      // if (!found) {
      //   mainMenuItems.splice(uidx, 1);
      // } else {
      let pidx = mainMenuItems.findIndex(el => el.name === 'POS')
      if (pidx > -1) {
        let addStore = userItems.findIndex(el => el.name === 'Store User')
        if (addStore < 0) {
          userItems.push({
            to: '/store-user',
            name: 'Store User',
            exact: true,
            Icon: MdDomain,
          })
        }
      }

      let cidx = mainMenuItems.findIndex(el => el.name === 'CRM')
      if (cidx > -1) {
        let addCrm = userItems.findIndex(el => el.name === 'CRM User')
        if (addCrm < 0) {
          userItems.push({
            to: '/crm-user',
            name: 'CRM User',
            exact: true,
            Icon: FaRegIdCard,
          })
        }
      }
      //}
    }

    return (
      <aside className={bem.b()} data-image={sidebarBgImage}>
        <div className={bem.e('background')} />
        <div className={bem.e('content')}>
          <Navbar className="ps-sidebar-title">
            <SourceLink className="navbar-brand d-flex">
              <span className="text-white">
                <span style={{ color: '#00ADAD', fontWeight: '600' }}>Unity</span>
                Suite
              </span>
            </SourceLink>
          </Navbar>
          <div className="duol-sidebar">
            <div className="ps-appbar">
              <Nav className="ps-appbar-item" vertical>
                {mainMenuItems.map(({ to, name, exact, Icon, id }, idx) => (
                  <NavItem key={idx} className={bem.e('nav-item')}>
                    <BSNavLink id={`navItem-${name}-${idx}`} tag={NavLink} to={to} exact={exact} onClick={() => this.selectApp(id - 1)} data-toggle="tooltip" title={name} className={activeApp === id - 1 ? ' active' : ''}>
                      <Icon className={bem.e('nav-item-icon')} />
                    </BSNavLink>
                  </NavItem>
                ))}
              </Nav>
            </div>
            <div className="ps-sidemenu">
              <Nav className="ps-sidebar" vertical>
                {mainMenuItems.length > 0 &&
                  appItems[activeApp].menu.map(({ to, name, exact, Icon }, index) => (
                    <NavItem key={index} className={bem.e('nav-item')}>
                      <BSNavLink
                        id={`navItem-${name}-${index}`}
                        tag={NavLink}
                        to={to}
                        exact={exact}
                        className={(to === '/company' || to === '/site' || to === '/posstore' || to === '/crmcustomer' || to === '/company-user') && path === '/' ? 'active' : '/' + parentPath === to ? 'active' : ''}>
                        <Icon className={bem.e('nav-item-icon')} />
                        <span className="">{name}</span>
                      </BSNavLink>
                    </NavItem>
                  ))}
              </Nav>
            </div>
          </div>
        </div>
      </aside>
    )
  }
}

export default Sidebar
